<script lang="ts">
	import type { SplittedAddress } from '$lib/components/pois/types';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import ButtonAddToItinerary from '$lib/components/atoms/button/ButtonAddToItinerary.svelte';
	import SkeletonButton from '$lib/components/atoms/skeleton/SkeletonButton.svelte';
	import SkeletonText from '$lib/components/atoms/skeleton/SkeletonText.svelte';
	import * as m from '$paraglide/messages';
	import { createEventDispatcher } from 'svelte';

	export let address: SplittedAddress | null = null;
	export let isLoading = false;
	export let hasError = false;
	export let notFound = false;

	const dispatch = createEventDispatcher<{
		addClick: void;
		retryClick: void;
		cancelPosition: { cancelAction: boolean };
	}>();
</script>

<div class="flex flex-col relative rd-2 shadow-subtle p-2 min-w-0 bg-neutral-weakest w-full">
	<div data-testid="floating-summary--title" class="truncate text-md text-bold text-coloredneutral">
		{#if isLoading}
			<SkeletonText minWords={2} maxWords={3} minWordLength={6} maxWordLength={15} />
		{:else if hasError || notFound}
			{m.address__summary__error__title()}
		{:else if address !== null}
			{address.firstLine}
		{/if}
	</div>
	<div data-testid="floating-summary--detail" class="truncate text-sm text-coloredneutral mt-1">
		{#if isLoading}
			<SkeletonText minWords={2} maxWords={3} minWordLength={6} maxWordLength={15} />
		{:else if hasError || notFound}
			{m.address__summary__error__detail()}
		{:else if address !== null}
			{address.secondLine}
		{/if}
	</div>
	<div class="mt-2">
		{#if isLoading}
			<div class="flex gap-2">
				<SkeletonButton text={m.poi_actions__itinerary()} size="sm" hasIcon />
				<SkeletonButton text={m.poi_actions__cancel()} size="sm" />
			</div>
		{:else if hasError}
			<Button
				variant="outline"
				size="sm"
				icon="autorenew"
				text={m.action__retry()}
				onclick={() => dispatch('retryClick')}
			/>
		{:else if address && !notFound}
			<div class="flex gap-2">
				<ButtonAddToItinerary
					size="sm"
					onclick={() => dispatch('addClick')}
				/>
				<Button
					color="white"
					size="sm"
					text={m.poi_actions__cancel()}
					variant="filled"
					onclick={() => dispatch('cancelPosition', { cancelAction: true })}
				/>
			</div>
		{:else}
			<div class="btn-sm" />
		{/if}
	</div>
</div>
